import styled from '@emotion/styled';
import theme from '@vromo/ui/components/theme';
import Color from 'color';
import { lighten } from 'polished';
import { css } from 'emotion';

export const FilterRow = styled.div`
    display: flex;
    padding: 10px 0px;
    align-items: center;

    label {
        flex: 1;
        margin-right: 10px;
    }

    @media (max-width: 800px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const AddButton = styled.button`
    color: ${theme.primary};
    border: none;
    border-radius: 4px;
    padding: 10px;
    background-color: transparent;
    transition: all 200ms ease-in-out;

    &:hover,
    &:focus {
        color: ${Color(theme.primary)
            .darken(0.2)
            .toString()};
        background-color: ${Color(theme.primary)
            .lighten(0.5)
            .toString()};
    }
`;

export const TwoPageModal = styled.div`
    display: flex;
    justify-content: center;
    width: 65vw;
    height: 50vh;

    @media (max-width: 1000px) {
        width: 100%;
    }

    @media (max-width: 600px) {
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
        height: 100%;
    }
`;

export const Constraint = styled.div<{ color: string }>`
    padding: 4px 8px;
    margin-top: 5px;
    margin-left: 5px;
    font-size: 12px;
    border-radius: 5px;
    background-color: ${props => lighten(0.05, props.color)};
    color: white;
    font-weight: 400;
`;

export const closeButton = css`
    margin-left: 10px;
    color: ${theme.grey};
    cursor: pointer;
    transition: color 200ms ease-in;

    &:hover {
        color: red;
    }
`;

export const TaskContainer = styled.div`
    padding: 8px;

    padding: 15px 20px;
    margin-bottom: 8px;
    border: 1px solid ${theme.lightGrey};
    border-radius: 4px;
    box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.1);
    transition: all 200ms ease-in-out;

    cursor: pointer;

    & > div {
        margin-bottom: 5px;
    }

    &:hover {
        box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.15);
    }
`;

export const Flex = styled.div`
    flex: 1;
`;

export const GreyDivider = styled.div`
    margin: 20px;
    border: 1px solid ${theme.lightGrey};
`;

export const AddButtonContainer = css`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;
